"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var uploads_1 = require("../features/apis/uploads");
var FileUpload = function (_a) {
    var onUploadSuccess = _a.onUploadSuccess, _b = _a.currentValue, currentValue = _b === void 0 ? "" : _b, _c = _a.label, label = _c === void 0 ? "Upload Image" : _c, _d = _a.accept, accept = _d === void 0 ? "image/*" : _d, _e = _a.className, className = _e === void 0 ? "" : _e, _f = _a.showPreview, showPreview = _f === void 0 ? true : _f;
    var _g = (0, react_1.useState)(null), error = _g[0], setError = _g[1];
    var fileInputRef = (0, react_1.useRef)(null);
    // RTK Query mutation hook
    var _h = (0, uploads_1.useUploadImageMutation)(), uploadImage = _h[0], uploading = _h[1].isLoading;
    var handleFileSelect = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var file, response, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (!file)
                        return [2 /*return*/];
                    setError(null);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, uploadImage(file).unwrap()];
                case 2:
                    response = _c.sent();
                    if (response.success && response.content) {
                        onUploadSuccess(response.content.url, file);
                    }
                    else {
                        setError(response.message || "Upload failed");
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _c.sent();
                    setError(((_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.data) === null || _b === void 0 ? void 0 : _b.message) || "Upload failed");
                    return [3 /*break*/, 5];
                case 4:
                    // Reset the input
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleButtonClick = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-3 ".concat(className), children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-3", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleButtonClick, disabled: uploading, className: "px-4 py-2 border border-gray-300 rounded-md text-sm font-medium transition-colors ".concat(uploading
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-700 hover:bg-gray-50"), children: uploading ? "Uploading..." : label }), currentValue && showPreview && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2", children: [accept.includes("image") ? ((0, jsx_runtime_1.jsx)("img", { src: currentValue, alt: "Current", className: "w-8 h-8 object-cover rounded", onError: function (e) {
                                    e.currentTarget.style.display = "none";
                                } })) : ((0, jsx_runtime_1.jsx)("div", { className: "w-8 h-8 flex items-center justify-center bg-red-100 rounded", children: (0, jsx_runtime_1.jsxs)("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("path", { d: "M14 2H6C4.9 2 4 2.9 4 4v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6z", fill: "#dc2626" }), (0, jsx_runtime_1.jsx)("path", { d: "M14 2v6h6", stroke: "#dc2626", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] }) })), (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-500 truncate max-w-xs", children: currentValue.split("/").pop() })] })), currentValue && !showPreview && ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-green-600", children: "\u2713 File uploaded" }))] }), (0, jsx_runtime_1.jsx)("input", { ref: fileInputRef, type: "file", accept: accept, onChange: handleFileSelect, className: "hidden" }), error && (0, jsx_runtime_1.jsx)("div", { className: "text-red-600 text-sm", children: error }), uploading && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2 text-sm text-blue-600", children: [(0, jsx_runtime_1.jsx)("div", { className: "animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" }), (0, jsx_runtime_1.jsx)("span", { children: "Uploading..." })] }))] }));
};
exports.FileUpload = FileUpload;
